import { populate } from "populate";

const raw = {
  width: 0,
  height: 0,
  x: 50,
  y: 100,
  list: [
    {
      id: "1",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "2",
      type: "Container",
      name: "backgrounds",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "3",
      type: "Container",
      name: "nodesContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "4",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "5",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world18_1",
      parent: "2",
      data: ""
    },
    {
      id: "7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1352,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world18_2",
      parent: "2",
      data: ""
    },
    {
      id: "8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2704,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world18_3",
      parent: "2",
      data: ""
    },
    {
      id: "10",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5408,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world18_5",
      parent: "2",
      data: ""
    },
    {
      id: "9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4056,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world18_4",
      parent: "2",
      data: ""
    },
    {
      id: "11",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6760,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world18_6",
      parent: "2",
      data: ""
    },
    {
      id: "12",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8112,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world18_7",
      parent: "2",
      data: ""
    },
    {
      id: "13",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9464,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world18_8",
      parent: "2",
      data: ""
    },
    {
      id: "56df0195-6463-44b9-940d-5d3496e6e0cd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 167,
      y: 454,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "34008427-451a-4e00-9d20-488e947e81fd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 252,
      y: 511,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "6e3e21ac-9487-49e6-9f85-7c34f34f1ee9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 353,
      y: 541,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e56c6beb-9b89-4aea-a1e1-a9aba83aef46",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 454,
      y: 515,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e05364ce-7681-40a2-93ac-c6e1e85c12a5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 519,
      y: 438,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "18ca984c-a36b-4dc6-aaae-66f1b318a64a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 598,
      y: 377,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "83e520f1-a8a0-49a8-bd95-8aac268b2187",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 697,
      y: 422,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "1cdc2a80-88a1-4f60-bcf4-f5fc8be194dd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 779,
      y: 484,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "b756ff1d-d286-483e-9788-6acc6ef18373",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 871,
      y: 533,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "7986e969-ee84-4d41-b50b-09dc1812bc83",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 979,
      y: 512,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "9dd4f94a-8ebb-4f24-aa15-ee83c51919ea",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1033,
      y: 427,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "84d59fdc-9aeb-4246-8347-282a346adcb0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1074,
      y: 337,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "b508e1f7-5600-405a-8094-7b00d008f8c1",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1129,
      y: 257,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "641c2c20-f173-4a36-8bb2-bc633eba06ba",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1218,
      y: 200,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "55859278-0905-4fb4-be76-2510d74a0298",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1333,
      y: 195,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "436fb15e-5ae6-478e-8045-f6563aac99a2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1429,
      y: 247,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "ddf55266-b2cb-4a3e-ae0c-a3207b5961da",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1507,
      y: 316,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "03ebaa66-6c33-4191-b319-020faa5efafe",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1581,
      y: 391,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "47f9e612-e8b7-4d0f-ad05-027956cbb2c8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1656,
      y: 469,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "dfd3a830-808b-47e6-bc10-267dd8974b93",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1739,
      y: 534,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "46f30a11-92a8-4d3a-9c75-df0ddb1ea598",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1845,
      y: 571,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "a92e47d5-2f98-444c-b59f-0f575a3b7e9a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1937,
      y: 511,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "53ecef60-3476-4812-81c1-1e8016d5ddc7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2003,
      y: 428,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "24b0c418-6c43-431e-9c86-063b4608a102",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2086,
      y: 357,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "723555a0-e1a6-4fcf-aeda-ca9f281c2ce1",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2197,
      y: 326,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "cb257627-ad7a-4469-a11c-4adb21a2a2c7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2304,
      y: 357,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "3bb0f6f7-2b26-47f6-8f12-9af5dd8813bd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2383,
      y: 429,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "9244cda4-b520-439d-9848-22d0d65a5fcb",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2465,
      y: 498,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "df112896-703b-4f9b-a52e-908e2ffb9aee",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2565,
      y: 548,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "a4e14c1d-28b7-4af9-8e67-3e8a2f259fa4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2681,
      y: 555,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "4231c6a8-f053-450b-9ba7-396db177637d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2794,
      y: 532,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "5696db00-f14d-45a6-b9b8-38f6f7ac88f5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2904,
      y: 499,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "70952c8b-525a-44ae-8930-ecddb211a261",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3012,
      y: 458,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "41a3ae2d-f17d-4887-ab6f-cc9ec37a8bea",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3120,
      y: 415,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "b3e62846-68db-423a-b45d-985c78fb49c6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3237,
      y: 388,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "5b636286-fe42-46c6-bf4e-dd78dfa0ef03",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3361,
      y: 403,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e46e2fcd-ce84-4aad-8506-4eb860a5043e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3440,
      y: 480,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "75e10429-54e2-4018-ac35-e266491e3b28",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3522,
      y: 555,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "08bcba79-b3e0-440c-b3fa-a75c7bcf7c9d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3642,
      y: 560,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "4105abae-5486-4bba-9ab4-3873a82a6684",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3710,
      y: 471,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d32b4507-696a-40d3-8350-68e613c4ad82",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3748,
      y: 375,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "55e5e3a4-0512-4f22-b1a6-072b07a4e494",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3793,
      y: 280,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "b2ff511d-36a4-41de-8907-a5064e23b483",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3865,
      y: 197,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "75725fb6-b460-4b18-93af-2284cb61d0a6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3985,
      y: 196,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "f1637746-a627-4feb-b705-7823571d2805",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4072,
      y: 269,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "76d3e367-576e-42f5-aa3b-cd64e29ffa5f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4133,
      y: 359,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "ecce32d5-4365-4c10-8758-3e8ca70c40f4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4193,
      y: 445,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "5e84c8c9-b9de-4608-aec6-e571af5481af",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4268,
      y: 522,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "10b0ea84-832d-4c30-a9ce-5a67e58abcc9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4362,
      y: 576,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "b03ab8e3-5859-4564-b10c-8015dc0978ab",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4480,
      y: 565,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "65cb3b77-141b-4aba-ab68-c1561a6030e3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4564,
      y: 497,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e5eff58f-ba9e-4e9e-ac20-aa51bbb5947b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4628,
      y: 415,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "4d7a0f12-05c8-43cc-af1c-f73a761a8fa6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4701,
      y: 335,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "310200c5-7474-495d-acc8-4f77381bcade",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4813,
      y: 329,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "19b3b191-8509-4202-be64-cd110b1dd09d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4881,
      y: 407,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "8755ea02-e2be-4424-a93c-83bffd248bf2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4934,
      y: 495,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d230a2c4-90ca-4fe3-be11-9161b4af90db",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5025,
      y: 556,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "dab36e47-f335-413d-b1ba-998d5f6cb640",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5142,
      y: 536,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "ffd8bf2f-dffc-4583-9f6b-4a40587f26ec",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5237,
      y: 481,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "19c8b87c-53a8-432b-aee7-9df6e8858a3e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5345,
      y: 442,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "4e947fba-0f7f-49cc-aca7-e10cc86aed2b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5456,
      y: 427,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "3c721aa0-304b-4e16-8d24-d8e1b9296174",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5568,
      y: 405,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "dd717548-6eae-4d7e-a559-fe38a7c3f7f5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5667,
      y: 359,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d1c4ab6b-1754-4253-9573-5840ec62e3dd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5780,
      y: 340,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "dd1e6788-71be-4ecb-9da5-44a7eee9a3c6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5882,
      y: 381,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "7552ceb7-bdf0-4dcc-b25a-0599321b96ef",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5962,
      y: 453,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "df797c26-3c0b-4c94-8ed6-b8780d0a6712",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6040,
      y: 525,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "cfa83be3-ffd5-4687-87f0-8e0129da922e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6133,
      y: 580,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "a6c09616-eb5f-4646-b2cc-4b59f5c7ce8a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6249,
      y: 569,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "b80cf860-1be5-4ad0-83fd-0fa36c8f0e44",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6317,
      y: 488,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "b410da26-a22d-4633-a5f8-18c088016b00",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6357,
      y: 394,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "0842ae22-d829-47ef-bbbf-d0c6ab0e37b6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6414,
      y: 308,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e4a2c365-ced6-457e-901c-6d50a49a4734",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6518,
      y: 264,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "5a6f325b-f120-47b2-895d-6905bc1978e5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6616,
      y: 317,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "03c3dd7e-618d-4e6d-8933-e59394ace8df",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6685,
      y: 404,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "0c084cb8-f2d1-4dd4-b372-af9b6a5bc652",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6750,
      y: 495,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d22e5f7e-2422-4e5c-b2e4-ce29dbf82f9c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6863,
      y: 526,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e2484764-d8b4-4085-9f87-6a7082c3567b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6944,
      y: 452,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "977e1165-5223-4246-92b2-5ddb85534f02",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7011,
      y: 361,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "f19b583a-21ac-4597-b0d7-d2bb3bc96e1a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7087,
      y: 278,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "c6e8f722-35c7-454d-bf33-14a372149c0b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7187,
      y: 222,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "334f1abb-660e-4a6f-a5fc-9297a1e32aa0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7288,
      y: 272,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d5fa93fe-cb42-431d-929b-ffdb2d074c9d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7327,
      y: 368,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "db7b6e90-f05e-4b6c-8d5d-121da58db3dc",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7377,
      y: 466,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "22061edb-c857-447b-830c-9653c2b510e5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7452,
      y: 545,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "3fb103ad-c448-4f7d-83eb-81fed06d144d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7562,
      y: 583,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d11b090a-24b3-491a-b309-8ea0af69431e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7679,
      y: 589,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "08f64d13-198c-447b-9704-034e5d997da5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7798,
      y: 565,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "8f8b4f7e-a360-4d1b-a8b8-71eea2e5c39a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7913,
      y: 529,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "ece0c6d8-95b8-4b06-a21e-18ed9ce785d5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8018,
      y: 480,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "a996adc1-dbbb-471c-bb93-360a062c9798",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8132,
      y: 465,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "43ce3a19-89d6-47d3-a28c-ee3f40a4b535",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8234,
      y: 514,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "14c604fc-97e6-40ba-9b4f-bbd764cda722",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8335,
      y: 560,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "0dc2c71c-dfde-4b2d-9825-2503ed37cd9b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8452,
      y: 550,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "4ee12906-a209-407f-aa5f-f39b7c798ea3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8536,
      y: 483,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "f60bba18-42bf-4dbe-b874-8aea917ed349",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8605,
      y: 404,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "4dc476db-e114-4316-83fa-4531cddd75f5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8671,
      y: 323,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "6766f2ea-1d1f-45f9-ba1b-efb7ef0b3d60",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8748,
      y: 247,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "a0195e5a-c62f-41d2-8143-543c93414223",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8844,
      y: 190,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "0c50b4c8-db8b-47a1-9dfe-5fcfaaf000fb",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8960,
      y: 181,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "f5b26ccb-5f40-4e18-a857-57d32f00734a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9052,
      y: 243,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "06e6cc95-ddd2-4917-9948-6a2b467b88e4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9123,
      y: 317,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "9cdfc0c0-9aae-40ed-9a43-ddb7e93fa963",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9187,
      y: 401,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "11c77974-4022-438b-aa03-8e92541842fd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9260,
      y: 475,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "af3b71bf-f0c5-44c2-98ff-e2511f8a49ac",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9367,
      y: 512,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d0a94353-6320-4c0e-8aaf-e316167a8870",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9469,
      y: 469,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "1397096a-5429-4794-abbf-4a334368f42d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9556,
      y: 405,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "6216fda1-b36f-4516-8c03-877f1d7a9fae",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9644,
      y: 340,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "a3bcb8fe-7263-4cee-8e22-4a6cfa15b830",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9752,
      y: 318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "419f5596-54a2-41ef-bf0c-c2ecb0616b55",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9820,
      y: 396,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "82f9c1d9-005d-4655-8119-4ee4c303ce61",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9882,
      y: 478,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "440de566-5464-40cc-9f0e-7ad812a19b0a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9984,
      y: 506,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "21555a72-49b5-4d32-be74-e593fde51eda",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10043,
      y: 423,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "964398f1-b155-4709-a43b-22c4a5dbc38b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10065,
      y: 326,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "343ece12-582b-40b1-abea-f831f228735b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10110,
      y: 237,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "fd31e8cc-8fab-4fbe-939b-8722b4c28883",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10229,
      y: 228,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "d894cf6f-359e-4d33-a3f1-d68ce19073e4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10308,
      y: 298,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "f5ad66a1-1f04-4a3d-a870-9e8e0f08e231",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10359,
      y: 385,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "e7129709-8ad9-47ad-abef-3fcca9abe850",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10423,
      y: 466,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "7d3287d8-453e-4bd6-be81-f8f61c217725",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10534,
      y: 492,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "74",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "110",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "164",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "185",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "214",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "219",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "224",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "1b355a2e-d409-489c-8af4-a150c082b42b",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "106",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "160",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "181",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "210",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "215",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "220",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "225",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "230",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "51a711e4-42ab-465e-80c9-d9cfee921632",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 339,
      y: 765,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "ff9a78c7-376f-44b1-87e3-5610f3e175d2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 916,
      y: 289,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "97eb6956-910b-4909-895f-c2ba4672c836",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1282,
      y: 58,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "bc44de6d-6569-4ab0-9a73-a500c294c446",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 759,
      y: 292,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "7d2432fd-c2b2-4a97-8495-f1589296e7e8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 947,
      y: 76,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "bd65922d-44f6-4a56-86a3-1f13b42c0529",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1070,
      y: 34,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "cfff67a4-539a-4514-8866-b34cc7021c96",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1168,
      y: 115,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "dd4b88af-0752-4b4c-ba3d-d95e0a85c36f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1031,
      y: 201,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "3be4ab40-a27f-41fb-a0f2-fbc8eb8f8327",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1144,
      y: 563,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "dabc28a7-fc40-48a1-8be9-6e3e52676c74",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1355,
      y: 534,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "cc3dab20-773d-41d1-a0ae-125f59167f07",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1251,
      y: 472,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "da0a3edb-86b0-41a3-bca9-8379391c3fca",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1236,
      y: 666,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "bd140a9e-8cf1-4df6-825a-dbc6b3260ff9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1470,
      y: 598,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "df25e1b5-bb16-4f83-8c26-087159ef5b43",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1343,
      y: 736,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "99c15e14-33ab-415c-8014-e74d6190eb62",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1460,
      y: 801,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "0211d685-62c0-46bd-8355-e27f6cb2b0f8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1574,
      y: 864,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "81fc1cc6-faac-4c2d-be41-fc0f5d19101c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1692,
      y: 752,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "0c4ab4d4-a55b-4c10-82d8-114f43818aeb",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1579,
      y: 674,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "caa3502f-9b0f-43b7-bc2d-da2dc885697f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 847,
      y: 156,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "bec3e6b0-e144-4cfb-85eb-864187d5cca5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 600,
      y: 627,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "7c8253bd-c2d2-472d-9599-c28972caa7d2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 462,
      y: 727,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "99e7b3fe-4610-4fd7-bad6-a83898e0b739",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 728,
      y: 669,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "48607176-67c3-455a-aec2-f2d8722a3732",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 559,
      y: 828,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "b8812364-7e87-47f7-95a7-3a9edff77175",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 847,
      y: 753,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "f72f5319-360b-4a10-b682-9d0f86e0bfcb",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 692,
      y: 846,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "74",
      data: ""
    },
    {
      id: "2d5eb0e4-256a-4a42-ad74-91a2fd22050d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1547,
      y: 106,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "d29862c5-7bd9-4e72-99f6-02c82dafa846",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1742,
      y: 304,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "6d7b05c2-194d-42a7-b0b8-666f7c8185ee",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1682,
      y: 50,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "e34b4df7-b3c7-4be0-9fae-51029ba1039c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1785,
      y: 129,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "817e1d07-9815-4118-99d4-5819b663a929",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1900,
      y: 45,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "59c50a08-3265-4c39-b21a-bbed317b5f6b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1872,
      y: 280,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "7234437b-66e4-49a7-a8a8-e8c190ac0400",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2235,
      y: 544,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "b9a28ec0-698a-4637-a356-3dca7c20c68d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2127,
      y: 615,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "3714ab60-7e46-41be-9e05-0e875d868f7d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2327,
      y: 638,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "5f4fab86-cc8e-49ca-b86f-6d772e5fe407",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2226,
      y: 730,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "fb79d8b8-111c-412c-b78f-161764c17fe0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2124,
      y: 841,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "8cb908a0-cd7c-4d56-90e7-169093d674c7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2334,
      y: 845,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "25077282-4eae-4308-a908-19e846cc944e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2530,
      y: 873,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "063c78ee-d5fb-4ff3-b765-e52a45aaf7fc",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2448,
      y: 727,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "0b6ee2d6-88db-4caa-8a5f-97c1901f0bb3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2030,
      y: 733,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "8c25585a-ee43-4a3f-bbb4-62a45e7e43a0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2063,
      y: 45,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "e968208d-eb1f-43e1-bd6d-9a546fcc1d55",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1974,
      y: 181,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "0d1c64b4-dfdb-44ed-8ee1-f4c54cc59ff5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1637,
      y: 221,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_4",
      parent: "110",
      data: ""
    },
    {
      id: "55b1b852-6aa7-4edb-a196-4c8379b280cd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3234,
      y: 673,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_3",
      parent: "164",
      data: ""
    },
    {
      id: "2345b938-b676-452c-9d15-bf77d082fd9b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3399,
      y: 783,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_3",
      parent: "164",
      data: ""
    },
    {
      id: "329a0c5f-96fc-4ae7-ac84-823fbc275ac9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3446,
      y: 387,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_3",
      parent: "164",
      data: ""
    },
    {
      id: "718cb399-c4dc-4ccf-9cb4-4fd08fb7644f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3645,
      y: 321,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_3",
      parent: "164",
      data: ""
    },
    {
      id: "b2c7c96e-bfff-428c-b06d-02c78b87196a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3855,
      y: 775,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_3",
      parent: "164",
      data: ""
    },
    {
      id: "fa3f7b69-99fc-456c-822b-44327f71610c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3921,
      y: 509,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_3",
      parent: "164",
      data: ""
    },
    {
      id: "0f9f5bc2-6642-408c-b628-4b5799f0f698",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4076,
      y: 696,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_3",
      parent: "164",
      data: ""
    },
    {
      id: "986e7ba1-5b0f-4acd-ab15-17258a5bb495",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4520,
      y: 309,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_3",
      parent: "185",
      data: ""
    },
    {
      id: "447324d4-8f4e-4556-a0aa-63932835628f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4731,
      y: 235,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_3",
      parent: "185",
      data: ""
    },
    {
      id: "d2d9350e-a3b8-4f20-b32c-016954462f3f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4142,
      y: 209,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_3",
      parent: "185",
      data: ""
    },
    {
      id: "0cd0f1df-a01a-4c92-9162-eb33581b1620",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4308,
      y: 397,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_3",
      parent: "185",
      data: ""
    },
    {
      id: "dc7d1611-bc3b-476b-8959-15792f4e6cf3",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4759,
      y: 652,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_3",
      parent: "185",
      data: ""
    },
    {
      id: "65cd1785-31c7-4170-8e20-bb293f3f5355",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4925,
      y: 839,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_3",
      parent: "185",
      data: ""
    },
    {
      id: "bb7558c7-9e1d-4674-9e1a-09f7a12c9722",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6299,
      y: 153,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "9d5bb86c-01c5-481e-a760-00ee1c38d839",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6376,
      y: 198,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "527a606e-e4b4-4884-9b08-a7a07a55f287",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6221,
      y: 172,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "d0beead1-596b-4902-8092-37ae8f3c05e7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6314,
      y: 235,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "67bd4a12-2955-4d01-b89f-3e49d5c3c958",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6144,
      y: 201,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "a33e4e9c-18e8-498c-bd29-bb96d8944ee5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6221,
      y: 248,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "124e75c3-3248-4ede-8327-3f3816a2fa6e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6282,
      y: 306,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "f8690814-5ec5-4004-90c1-ddc86ff8083e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6092,
      y: 255,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "c6d57885-279a-4610-8427-cf42065046f0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6156,
      y: 320,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "6eda65ab-5b26-43e5-abde-d75480820607",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6234,
      y: 378,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "60ff3a93-fd64-452d-9e2a-f7437c2c9cd5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6003,
      y: 303,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "da4447e1-2241-4bf9-b9fd-8f44f3119799",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6061,
      y: 363,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "3f893ecf-b9a5-4e16-9965-86e703af401d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6130,
      y: 415,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "ffa6d3be-7c7e-4c99-9755-0b52a720c9bc",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6204,
      y: 460,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "2937bee0-c268-417f-b478-ef5c1b48a7ab",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6545,
      y: 489,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "9528b060-b478-4432-81aa-83b8578aff7f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6619,
      y: 552,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "36ec7b17-bc66-4313-984d-9abbe1a82287",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6477,
      y: 580,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "0c3d9acd-6fb6-4726-a7cc-793aae9106d7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6553,
      y: 650,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "01f8634d-5aa8-464b-8b31-603cba616e7c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6600,
      y: 731,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "7c51b235-2255-471f-b038-1508267c9d33",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6422,
      y: 665,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "284a43f2-6c60-486f-be57-c23b863194b1",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6341,
      y: 713,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "9212bcb0-9a09-4479-b570-a334ab2ae87b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6484,
      y: 735,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "ae5353a6-b521-4c23-b684-609ea63a3749",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6281,
      y: 787,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "7860c08a-8ef9-4d91-bd2a-f8bca1ced92a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6406,
      y: 782,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "c6ac903c-9dcc-4f68-b621-497b0953a7a1",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6679,
      y: 625,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "9d7140be-0ae8-43fe-a066-69fbd029063c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6713,
      y: 714,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "bfcee584-f10b-4c9a-99fd-b5dea64aebcc",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6667,
      y: 798,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "c96b67b7-50ae-4b26-aecc-245150f32702",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6538,
      y: 822,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "214",
      data: ""
    },
    {
      id: "f39e64cb-1e58-46e5-a337-9cf3bcdf93ee",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6982,
      y: 151,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "fc6b124c-e9db-423a-9c4d-3ec9b1525017",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7040,
      y: 213,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "8ef1b037-5bae-45c7-901d-c3f83822ac65",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6899,
      y: 168,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "bfdad119-b668-4143-8e46-35a718b0f70a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6968,
      y: 237,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "b909d12a-cdc7-474c-9221-4138c22a0ab7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6803,
      y: 173,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "cece40ee-dede-4770-844f-40b7cccc0bd4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6869,
      y: 250,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "2e5c3394-57cb-46f3-ad33-85c2a0efaefd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6930,
      y: 308,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "6f258e3b-70ed-497b-948e-2253cbfc74f0",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6712,
      y: 167,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "ebc53a1b-2dea-4fba-a7e1-fd3fe544ac60",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6786,
      y: 245,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "241c0921-9fbb-47d2-b6a9-350f91ad062f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6852,
      y: 317,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "c7040d27-fb9b-4a2a-83df-95f5191a1492",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6634,
      y: 185,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "ecc7f900-9cee-4f7f-997f-57684c246074",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6699,
      y: 243,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "842d6e0e-98b6-41f1-9eb3-42db495cf45f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6766,
      y: 317,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "4922606f-bbe2-4f78-bd68-b75cfa2774e8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6841,
      y: 393,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "5f1fea08-cf8e-4f17-a55a-34dcd83a2370",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7172,
      y: 473,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "a3bb5a11-01e1-4525-9798-e0ae9d599a9a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7244,
      y: 540,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "510a5fba-2beb-4778-885e-01aa31f3c3eb",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7310,
      y: 609,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "f692f14b-7044-44b6-8281-368df21e325a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7374,
      y: 681,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "f8207d59-cb0e-47c1-82f2-b6b5ae50910a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7442,
      y: 753,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "e116cb50-fea9-406e-bcca-ec85c605ba4d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7116,
      y: 555,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "3eea8d2f-0f60-4ae5-b974-edaa40958d12",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7183,
      y: 614,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "491b9422-c55b-4ce6-afe1-810afa38f1b4",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7245,
      y: 682,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "bbe58554-f12c-4db1-957c-2a62bd942e02",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7311,
      y: 753,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "09830fcf-264f-4ae1-8363-496c870761fc",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7047,
      y: 619,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "29074f9c-a985-453f-b7ca-e2acd8f90815",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7118,
      y: 688,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "3741d604-54b5-49a0-b10e-14e92d92e309",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7179,
      y: 754,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "90091159-2e70-422b-afcf-4ffcece955b5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6985,
      y: 691,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "e2451ee6-b5d0-4ee1-a7ab-0b2887171578",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7054,
      y: 761,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "973f3d99-e842-41d8-8c6f-43eb4541bc39",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6936,
      y: 772,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "768d54c6-4a6e-42d5-8f10-d81e5c78892c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7477,
      y: 180,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "8cf210d2-6eee-45d5-951d-4910a4e4c64c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7574,
      y: 203,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "9de14725-dc05-4e86-b572-8d27d8ec2ff9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7686,
      y: 224,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "88050d5b-61b6-499b-9861-f494e0760677",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7434,
      y: 259,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "200af5a5-c813-4cef-a257-7a3fdf06e8b6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7535,
      y: 281,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "cede6769-709c-4bc6-8aff-1c6270b80981",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7643,
      y: 302,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "e9193e10-9d49-4e40-a6ac-23ad120b568b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7749,
      y: 326,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "9864ec32-a821-4536-9bb6-bd339f9c4d7f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7859,
      y: 351,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "4c65cbc0-75a7-4968-b49b-e1158c93232b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7790,
      y: 249,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "6073fd23-007f-4f3a-9bea-37d8bd40ebb6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7494,
      y: 358,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "dd257a8d-11e7-4880-ad1f-f5ed61298e6d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7596,
      y: 380,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "9f78df50-c86e-46d8-a469-53c09800c868",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7704,
      y: 404,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "94d0e2d1-f5ec-4542-8422-48e7bfc677c7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7810,
      y: 425,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "020e0d6e-3302-4f1f-9f2c-1bff875fe33a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7533,
      y: 441,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "99b8e700-d62f-49f4-b964-fa2a8cb9fe7f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7634,
      y: 462,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "06d61cb4-2b8f-4333-bb69-347255dd1f7d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7744,
      y: 479,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "2c62875e-5a09-43a7-92dd-84160551e4bd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7908,
      y: 434,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_4",
      parent: "219",
      data: ""
    },
    {
      id: "85d1911c-be3e-4628-b915-bb6ade0a142c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8383,
      y: 450,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hazelnut_3",
      parent: "224",
      data: ""
    },
    {
      id: "79a08ad8-099f-4c32-8747-91d03b1d9553",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8569,
      y: 308,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hazelnut_3",
      parent: "224",
      data: ""
    },
    {
      id: "af4aea6f-2f4a-4c27-beaa-ac7dfc886be5",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8744,
      y: 717,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hazelnut_3",
      parent: "224",
      data: ""
    },
    {
      id: "ec4537b5-f199-40f2-a7be-37b0dde75134",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9042,
      y: 707,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hazelnut_3",
      parent: "224",
      data: ""
    },
    {
      id: "636d10d0-0ceb-407e-bf5a-e8734e89a98a",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8889,
      y: 578,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hazelnut_3",
      parent: "224",
      data: ""
    },
    {
      id: "17fa669a-7cd6-49a7-a748-ce03de68bf05",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9742,
      y: 247,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hazelnut_3",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "9a7373f1-801c-46ee-8058-fc4b944912a6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9946,
      y: 333,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hazelnut_3",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "0026ef87-cd68-49ad-b769-e03d5b8d93fb",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9519,
      y: 317,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hazelnut_3",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "7dadba5c-d886-4253-b2d0-49fbd8a59da7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9627,
      y: 767,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hazelnut_3",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "8ac5d0c5-40fb-4078-b5d9-f4b36011b641",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9848,
      y: 861,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hazelnut_3",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "c080d9ae-97b3-40a5-8542-4fa9364a30f2",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10208,
      y: 652,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hazelnut_3",
      parent: "1b355a2e-d409-489c-8af4-a150c082b42b",
      data: ""
    },
    {
      id: "2260d25b-22ed-4df5-b6ea-1bcb9caebc8c",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 859,
      y: 184,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "106",
      data: ""
    },
    {
      id: "460cfc1c-9225-4169-8dcb-f719f9865b1d",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1794,
      y: 254,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "160",
      data: ""
    },
    {
      id: "15ecb407-34dd-49fd-94d1-15dd5136e53f",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3567,
      y: 260,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "181",
      data: ""
    },
    {
      id: "44e93875-1962-4c55-ba54-c3293bb0e9ea",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4427,
      y: 381,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "210",
      data: ""
    },
    {
      id: "107",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6173,
      y: 364,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "215",
      data: ""
    },
    {
      id: "f91af2df-8d3d-49a3-8040-33bebb847e55",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7175,
      y: 471,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "220",
      data: ""
    },
    {
      id: "e5a00353-b3ea-4436-b6f7-619f1dcc42d9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8895,
      y: 548,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "225",
      data: ""
    },
    {
      id: "4f3d25a5-5ef3-4047-a7ae-61f2040e854e",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10211,
      y: 512,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "230",
      data: ""
    },
    {
      id: "e9b75b1f-8160-4ef5-b5b9-9efa162189aa",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "2260d25b-22ed-4df5-b6ea-1bcb9caebc8c",
      data: ""
    },
    {
      id: "85746295-e987-4e2b-a7d0-6791216b55a9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_harvest_map",
      parent: "2260d25b-22ed-4df5-b6ea-1bcb9caebc8c",
      data: ""
    },
    {
      id: "8760c148-9cef-4f28-9a17-22e855cf0c84",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "460cfc1c-9225-4169-8dcb-f719f9865b1d",
      data: ""
    },
    {
      id: "656a5808-34d6-4751-a733-6af98d163ac6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cotton_harvest_map",
      parent: "460cfc1c-9225-4169-8dcb-f719f9865b1d",
      data: ""
    },
    {
      id: "c001f4bb-2f73-4bf8-8953-deb543c31f21",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "15ecb407-34dd-49fd-94d1-15dd5136e53f",
      data: ""
    },
    {
      id: "c41c933b-373f-4a3d-bdc7-f748ce87c274",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_harvest_map",
      parent: "15ecb407-34dd-49fd-94d1-15dd5136e53f",
      data: ""
    },
    {
      id: "16ac1fb4-d061-449e-87ad-02f0d5dff6e9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "44e93875-1962-4c55-ba54-c3293bb0e9ea",
      data: ""
    },
    {
      id: "958851db-006d-425c-afff-a85018a3cb2b",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "fig_harvest_map",
      parent: "44e93875-1962-4c55-ba54-c3293bb0e9ea",
      data: ""
    },
    {
      id: "108",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "107",
      data: ""
    },
    {
      id: "109",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_harvest_map",
      parent: "107",
      data: ""
    },
    {
      id: "46aeb65d-4896-4557-9865-75ef0057e163",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "f91af2df-8d3d-49a3-8040-33bebb847e55",
      data: ""
    },
    {
      id: "ac0db26e-8010-4059-87b0-18b44d3c25ca",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "sugarbeet_harvest_map",
      parent: "f91af2df-8d3d-49a3-8040-33bebb847e55",
      data: ""
    },
    {
      id: "03074616-c479-4d19-9e8c-855582627513",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "e5a00353-b3ea-4436-b6f7-619f1dcc42d9",
      data: ""
    },
    {
      id: "018bb44b-6ca0-491c-b479-368ca2fa6897",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hazelnut_harvest_map",
      parent: "e5a00353-b3ea-4436-b6f7-619f1dcc42d9",
      data: ""
    },
    {
      id: "2e08b7f7-57a1-4e7c-baf5-459d9f88afdd",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "4f3d25a5-5ef3-4047-a7ae-61f2040e854e",
      data: ""
    },
    {
      id: "c077834a-7855-43ec-a465-2f5ed5df5421",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "hazelnut_harvest_map",
      parent: "4f3d25a5-5ef3-4047-a7ae-61f2040e854e",
      data: ""
    }
  ]
} as const;

export class WorldLayout18 {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  backgrounds: GameObject<PIXI.Container>;
  nodesContainer: GameObject<PIXI.Container>;
  cropsSectorA: (GameObject<PIXI.Container>)[];
  cropsSectorB: (GameObject<PIXI.Container>)[];
  signsSectorA: (GameObject<PIXI.Container>)[];
  signsSectorB: (GameObject<PIXI.Container>)[];

  constructor() {
    populate(this, raw);
  }
}
